import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormLabel, MenuItem, Select, Typography } from '@mui/material';
import { useCommonStyles } from '../../styles/GenericStyle';
import { MtComStyleObj } from '../../styles/MtComStyleObj';
import { greyDark } from '../../colors';

type CleaningSkipConfirmDialogProps = {
    open: boolean;
    reason: string;
    onReasonChange: (reason: string) => void;
    onCancel: () => void;
    onConfirm: () => void;
};

const CLEANING_SKIP_REASONS = ['Manual cleaning', 'Equipment unavailable', 'Others'];

export default function CleaningSkipConfirmDialog({ open, reason, onReasonChange, onCancel, onConfirm }: CleaningSkipConfirmDialogProps) {
    const classes = useCommonStyles();

    return (
        <Dialog
            open={open}
            onClose={onCancel}
            maxWidth="xs"
            fullWidth
            slotProps={{ paper: { sx: { borderRadius: '16px' } } }}
            sx={(theme) => ({ ...MtComStyleObj(theme).drllDownCommentDialog })}
        >
            <DialogTitle sx={{ pb: 0, p: 3 }}>
                <Typography component="div" className={classes.labelNoto20Bold600}>
                    Confirm Skip
                </Typography>
            </DialogTitle>
            <Divider sx={(theme) => ({ ...MtComStyleObj(theme).dividerStyle, mt: 0 })} />
            <DialogContent sx={{ pt: 2, pb: 1 }}>
                <Typography className={classes.labelInter14Bold400} sx={{ mb: 2, color: '#404040' }}>
                    Are you sure you don't want to enter the equipment detail?
                </Typography>
                <FormControl fullWidth size="small">
                    <FormLabel sx={{ color: greyDark, mb: 1 }} className={classes.labelInter14Bold400}>Reason</FormLabel>
                    <Select
                        displayEmpty
                        value={reason}
                        onChange={(event) => onReasonChange(event.target.value)}
                        sx={(theme) => ({
                            ...MtComStyleObj(theme).fieldFocusHoverStyle,
                            ...MtComStyleObj(theme).textBoxValueStyle,
                            height: 40,
                        })}
                        renderValue={(selected) => selected ? String(selected) : <Typography component="span" className={classes.labelNoto16Bold400} color="text.secondary">Select reason (optional)</Typography>}
                    >
                        {CLEANING_SKIP_REASONS.map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions sx={{ mb: 2, mt: 2, px: 3 }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, width: '100%' }}>
                    <Button variant="contained" disableRipple className={classes.whiteButton} onClick={onCancel}>Cancel</Button>
                    <Button variant="contained" disableRipple className={classes.greenButton} onClick={onConfirm}>Confirm</Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}